import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";

import { Field, Control, Label, Input } from "rbx";

import { usePasswordStrength } from "../../hooks";

const ConfirmPasswordInput = ({ password, required, onChange }) => {
  const [confirmPassword, setConfirmPassword] = useState("");
  const [isValid, setIsValid] = useState(false);

  const requirements = usePasswordStrength(password);
  const meetsRequirements = !requirements.some(
    requirement => !requirement.result
  );

  useEffect(() => {
    setIsValid(
      password &&
        password.length &&
        confirmPassword.length &&
        password === confirmPassword &&
        meetsRequirements
    );
  }, [password, confirmPassword, meetsRequirements]);

  return (
    <React.Fragment>
      <Field kind="group">
        <Control expanded>
          <Label>Password</Label>
          <Input
            autocomplete="new-password"
            color={isValid ? "success" : "danger"}
            name="Password"
            required={required}
            type="password"
            value={password}
            onChange={onChange}
          />
        </Control>
        <Control expanded>
          <Label>Confirm Password</Label>
          <Input
            autocomplete="new-password"
            color={isValid ? "success" : "danger"}
            name="ConfirmPassword"
            required={required}
            type="password"
            value={confirmPassword}
            onChange={e => {
              setConfirmPassword(e.target.value);
              onChange(e);
            }}
          />
        </Control>
      </Field>
      <ul style={{ paddingLeft: "1rem" }}>
        {requirements.map(requirement => (
          <li
            style={{
              fontSize: 12,
              color: requirement.result ? "#31b522" : "#e63462"
            }}
          >
            {requirement.description}
          </li>
        ))}
      </ul>
    </React.Fragment>
  );
};

ConfirmPasswordInput.propTypes = {
  password: PropTypes.string,
  onChange: PropTypes.func,
  required: PropTypes.bool
};
ConfirmPasswordInput.defaultProps = {
  password: "",
  required: true
};
export default ConfirmPasswordInput;
